export default __webpack_public_path__ + "static/media/stockeer_logo.1f9d96c7.png";